/*
 * Forge Maestro
 * (c) Honeywell
 */

var IconName;
(function (IconName) {
    IconName["Alert"] = "alert";
    IconName["AlertCircle"] = "alert-circle";
    IconName["ArrowDown"] = "arrow-down";
    IconName["AreaChart"] = "area-chart";
    IconName["ArrowLeft"] = "arrow-left";
    IconName["ArrowRight"] = "arrow-right";
    IconName["ArrowUp"] = "arrow-up";
    IconName["ArrowUpDiagonal"] = "arrow-up-diagonal";
    IconName["ArrowDownDiagonal"] = "arrow-down-diagonal";
    IconName["Attach"] = "attach";
    IconName["Avatar"] = "avatar";
    IconName["Bell"] = "bell";
    IconName["BellOff"] = "bell-off";
    IconName["Bookmark"] = "bookmark";
    IconName["HoneywellLogo"] = "HoneywellLogo";
    IconName["Calendar"] = "calendar";
    IconName["Camera"] = "camera";
    IconName["Chat"] = "chat";
    IconName["Check"] = "check";
    IconName["ChevronUp"] = "chevron-up";
    IconName["ChevronDown"] = "chevron-down";
    IconName["ChevronLeft"] = "chevron-left";
    IconName["ChevronRight"] = "chevron-right";
    IconName["ChevronsDown"] = "chevrons-down";
    IconName["ChevronsLeft"] = "chevrons-left";
    IconName["ChevronsRight"] = "chevrons-right";
    IconName["ChevronsUp"] = "chevrons-up";
    IconName["Clock"] = "clock";
    IconName["Close"] = "close";
    IconName["CloseCircle"] = "close-circle";
    IconName["Columns"] = "columns";
    IconName["Comment"] = "comment";
    IconName["Copy"] = "copy";
    IconName["DensityLeast"] = "density-least";
    IconName["DensityMedium"] = "density-medium";
    IconName["DensityMost"] = "density-most";
    IconName["Description"] = "description";
    IconName["Edit"] = "edit";
    IconName["Error"] = "error";
    IconName["Failed"] = "failed";
    IconName["Favorite"] = "favorite";
    IconName["Filter"] = "filter";
    IconName["FilterAscendingSort"] = "filter-ascending-sort";
    IconName["FilterDescendingSort"] = "filter-descending-sort";
    IconName["FilterRemove"] = "filter-remove";
    IconName["Grabber"] = "grabber";
    IconName["Graph"] = "graph";
    IconName["Group"] = "group";
    IconName["Grid"] = "grid";
    IconName["Help"] = "help";
    IconName["Hide"] = "hide";
    IconName["History"] = "history";
    IconName["Home"] = "home";
    IconName["Import"] = "import";
    IconName["Info"] = "info";
    IconName["Link"] = "link";
    IconName["Lock"] = "lock";
    IconName["Maximize"] = "maximize";
    IconName["Menu"] = "menu";
    IconName["Minimize"] = "minimize";
    IconName["Minus"] = "minus";
    IconName["ModelCreation"] = "model-creation";
    IconName["Monitor"] = "monitor";
    IconName["MoreHorizontal"] = "more-horizontal";
    IconName["MoreVertical"] = "more-vertical";
    IconName["OpenInNew"] = "open-in-new";
    IconName["Pause"] = "pause";
    IconName["Pin"] = "pin";
    IconName["PinAlt"] = "pin-alt";
    IconName["Placeholder"] = "place-holder";
    IconName["Play"] = "play";
    IconName["Plus"] = "plus";
    IconName["Progress"] = "progress";
    IconName["ProgressAlt"] = "progress-alt";
    IconName["Question"] = "question";
    IconName["Recent"] = "recent";
    IconName["Redo"] = "redo";
    IconName["Refresh"] = "refresh";
    IconName["Search"] = "search";
    IconName["Send"] = "send";
    IconName["Settings"] = "settings";
    IconName["Share"] = "share";
    IconName["ShareAlt"] = "share-alt";
    IconName["Show"] = "show";
    IconName["SignOut"] = "sign-out";
    IconName["Slider"] = "slider";
    IconName["SortAscending"] = "sort-ascending";
    IconName["SortDescending"] = "sort-descending";
    IconName["Stop"] = "stop";
    IconName["Success"] = "success";
    IconName["TimePeriod"] = "time-period";
    IconName["ToolJira"] = "tool-jira";
    IconName["Trash"] = "trash";
    IconName["Trend"] = "trend";
    IconName["Undo"] = "undo";
    IconName["Unlink"] = "unlink";
    IconName["Unlock"] = "unlock";
    IconName["Unpin"] = "unpin";
    IconName["UnpinAlt"] = "unpin-alt";
})(IconName || (IconName = {}));

export { IconName };
//# sourceMappingURL=IconName.enum.js.map
